/**
 * HEARTEN Pure Cold-Pressed Cooking Oils - Shopify Theme JavaScript Controller
 * 100% Exact Matching Implementation of Local Prototype Logic & Shopify AJAX Sync
 */

// ================= 16 PRODUCTS ACROSS CORE CATEGORIES (DARKHSHAN OIL CO. JULY 2026 RATES) =================
const productsDB = [
  // ================= CATEGORY 1: EXTRA VIRGIN COLD PRESSED (UNPROCESSED) =================
  {
    id: "prod-ev-canola",
    categoryId: "extra-virgin",
    category: "Extra Virgin Cold Pressed (Unprocessed)",
    categoryBadge: "100% PURE · UNPROCESSED",
    name: "HEARTEN Extra Virgin Cold Pressed Canola Oil",
    subtitle: "100% Pure First Cold-Pressed Unprocessed Canola Oil",
    grade: "Extra Virgin (Unprocessed)",
    price: 1600,
    sizes: [
      { label: "01 Liter Packing", price: 1600, default: true, img: "1-liter.png" },
      { label: "03 Litre Packing", price: 4500, img: "3-liter.png" }
    ],
    size: "01 Liter Packing",
    origin: "Selected Non-GMO Canola Harvest · Darkhshan Certified",
    groveCoordinates: "Certified Pure Seed · Single Harvest",
    smokePoint: "470°F (243°C)",
    acidity: "< 0.08% (Ultra Pure)",
    polyphenols: "High Omega-3, Omega-6 & Natural Tocopherols",
    extraction: "Mechanical Cold Expeller Press (< 22°C) · Hexane Free",
    harvestDate: "July 2026 Rate Release",
    rating: 5.0,
    reviewsCount: 148,
    badge: "EXTRA VIRGIN · UNPROCESSED",
    description: "100% pure first cold mechanical expeller press extracted below 22°C without chemical solvents or refining. Completely unadulterated, preserving natural bioactive Omega-3 lipids, pure antioxidants, and raw culinary vitality.",
    culinaryUses: "Heart-healthy daily cooking, low-temperature pan sautéing, fresh salad dressings, and organic family nutrition.",
    images: ["1-liter.png", "3-liter.png"],
    image: "1-liter.png"
  },
  {
    id: "prod-ev-reserve",
    categoryId: "extra-virgin",
    category: "Extra Virgin Cold Pressed (Unprocessed)",
    categoryBadge: "SINGLE HARVEST RESERVE",
    name: "HEARTEN Unprocessed Golden Seed Reserve",
    subtitle: "Raw Cold Expeller First Decant Canola Oil",
    grade: "Extra Virgin (Unprocessed)",
    price: 1600,
    sizes: [
      { label: "01 Liter Packing", price: 1600, default: true, img: "1-liter.png" },
      { label: "03 Litre Packing", price: 4500, img: "3-liter.png" }
    ],
    size: "01 Liter Packing",
    origin: "Golden Seed Heritage Fields · Darkhshan Reserve",
    groveCoordinates: "Non-GMO Certified Prairie Harvest",
    smokePoint: "470°F (243°C)",
    acidity: "< 0.07% (Zero Refinement)",
    polyphenols: "Intact Plant Sterols & Vitamin E",
    extraction: "Raw Mechanical Decanting (< 20°C)",
    harvestDate: "July 2026 Rate Release",
    rating: 4.9,
    reviewsCount: 112,
    badge: "SINGLE HARVEST RESERVE",
    description: "Single-origin raw golden seed harvest decanted immediately after cold pressing. Zero thermal exposure, zero bleaches, and zero additives for pristine heart wellness and kitchen purity.",
    culinaryUses: "Light stove cookery, heart-care meal prep, herbal dips, salad emulsions, and wholesome morning recipes.",
    images: ["1-liter.png", "3-liter.png"],
    image: "1-liter.png"
  },
  {
    id: "prod-ev-estate",
    categoryId: "extra-virgin",
    category: "Extra Virgin Cold Pressed (Unprocessed)",
    categoryBadge: "NON-GMO CERTIFIED",
    name: "HEARTEN Single-Estate Virgin Canola Oil",
    subtitle: "Pure Certified Non-GMO Mechanical Press",
    grade: "Extra Virgin (Unprocessed)",
    price: 1600,
    sizes: [
      { label: "01 Liter Packing", price: 1600, default: true, img: "1-liter.png" },
      { label: "03 Litre Packing", price: 4500, img: "3-liter.png" }
    ],
    size: "01 Liter Packing",
    origin: "Estate Harvested Pure Canola Fields",
    groveCoordinates: "Designated Estate Farm Plots",
    smokePoint: "470°F (243°C)",
    acidity: "< 0.09% (Estate Grade)",
    polyphenols: "Rich Alpha-Linolenic Acid (Omega-3)",
    extraction: "Slow Stone Expeller Mechanical Decant",
    harvestDate: "July 2026 Rate Release",
    rating: 5.0,
    reviewsCount: 94,
    badge: "NON-GMO CERTIFIED",
    description: "Single-estate cold pressed virgin oil crafted from strictly verified non-GMO seeds. Delivers natural golden color, smooth viscosity, and uncompromised nutritional integrity.",
    culinaryUses: "Conscious cooking, light roasting, family curries, and wholesome vegetable searing.",
    images: ["1-liter.png", "3-liter.png"],
    image: "1-liter.png"
  },
  {
    id: "prod-ev-raw",
    categoryId: "extra-virgin",
    category: "Extra Virgin Cold Pressed (Unprocessed)",
    categoryBadge: "ZERO CHEMICAL HEXANE",
    name: "HEARTEN Raw First-Decant Canola Harvest",
    subtitle: "Artisanal Unrefined Cold Pressed Cooking Oil",
    grade: "Extra Virgin (Unprocessed)",
    price: 1600,
    sizes: [
      { label: "01 Liter Packing", price: 1600, default: true, img: "1-liter.png" },
      { label: "03 Litre Packing", price: 4500, img: "3-liter.png" }
    ],
    size: "01 Liter Packing",
    origin: "Darkhshan Select Harvest",
    groveCoordinates: "Clean Agricultural Groves",
    smokePoint: "470°F (243°C)",
    acidity: "< 0.08% (Unrefined Purity)",
    polyphenols: "Natural Plant Antioxidants",
    extraction: "Nitrogen-Sealed Cold Expeller (< 22°C)",
    harvestDate: "July 2026 Rate Release",
    rating: 4.9,
    reviewsCount: 87,
    badge: "ZERO CHEMICAL HEXANE",
    description: "Unfiltered, unrefined first-run canola pressing sealed with protective nitrogen. Free from all preservatives, deodorizers, and petroleum solvents.",
    culinaryUses: "Artisanal cooking, vinaigrettes, bread dipping, warm grain bowls, and gentle sautéing.",
    images: ["1-liter.png", "3-liter.png"],
    image: "1-liter.png"
  },

  // ================= CATEGORY 2: COLD PRESSED 'A' QUALITY (SLIGHTLY TREATED) =================
  {
    id: "prod-cpa-prime",
    categoryId: "cold-pressed-a",
    category: "Cold Pressed 'A' Quality (Slightly Treated)",
    categoryBadge: "'A' QUALITY GRADE",
    name: "HEARTEN Cold Pressed 'A' Quality Canola Oil",
    subtitle: "Premium Grade Slightly Treated Pure Cooking Oil",
    grade: "Cold Pressed A Quality (Slightly Treated)",
    price: 1200,
    sizes: [
      { label: "01 Liter Packing", price: 1200, default: true, img: "1-liter.png" },
      { label: "03 Litre Packing", price: 3400, img: "3-liter.png" }
    ],
    size: "01 Liter Packing",
    origin: "Premium Selected Crop Fields",
    groveCoordinates: "Darkhshan Standard Fields",
    smokePoint: "460°F (238°C)",
    acidity: "< 0.10% (Clean Standard)",
    polyphenols: "Natural Vitamin E & Phytosterols",
    extraction: "Cold Expeller Press + Natural Cotton Micro-Filter",
    harvestDate: "July 2026 Rate Release",
    rating: 4.9,
    reviewsCount: 165,
    badge: "'A' QUALITY GRADE",
    description: "Carefully pressed using low-temperature expeller technology followed by gentle micro-clarification. Offers a beautifully clear texture, neutral aromatic profile, and balanced cholesterol defense.",
    culinaryUses: "Everyday frying, shallow pan cooking, stir-fries, homestyle curries, and wholesome baking.",
    images: ["1-liter.png", "3-liter.png"],
    image: "1-liter.png"
  },
  {
    id: "prod-cpa-family",
    categoryId: "cold-pressed-a",
    category: "Cold Pressed 'A' Quality (Slightly Treated)",
    categoryBadge: "FAMILY HEALTH CHOICE",
    name: "HEARTEN 'A' Grade Healthy Daily Cooking Oil",
    subtitle: "Heart-Healthy Low-Cholesterol Kitchen Oil",
    grade: "Cold Pressed A Quality (Slightly Treated)",
    price: 1200,
    sizes: [
      { label: "01 Liter Packing", price: 1200, default: true, img: "1-liter.png" },
      { label: "03 Litre Packing", price: 3400, img: "3-liter.png" }
    ],
    size: "01 Liter Packing",
    origin: "Certified Clean Agriculture Harvest",
    groveCoordinates: "High Yield Pure Plantations",
    smokePoint: "460°F (238°C)",
    acidity: "< 0.10% (Low Acidity)",
    polyphenols: "Balanced Omega-3 & Omega-6",
    extraction: "Mechanical Expeller with Gentle Clarification",
    harvestDate: "July 2026 Rate Release",
    rating: 4.8,
    reviewsCount: 130,
    badge: "FAMILY HEALTH CHOICE",
    description: "Designed for health-conscious families who want the nutritional benefits of cold-pressed oil with smooth cooking versatility and high heat tolerance.",
    culinaryUses: "Family meals, daily gravies, egg preparation, parathas, and light pan grilling.",
    images: ["1-liter.png", "3-liter.png"],
    image: "1-liter.png"
  },
  {
    id: "prod-cpa-culinary",
    categoryId: "cold-pressed-a",
    category: "Cold Pressed 'A' Quality (Slightly Treated)",
    categoryBadge: "CULINARY MASTER GRADE",
    name: "HEARTEN Cold-Pressed Pure Culinary Canola",
    subtitle: "All-Purpose Gourmet Pan & Sauté Oil",
    grade: "Cold Pressed A Quality (Slightly Treated)",
    price: 1200,
    sizes: [
      { label: "01 Liter Packing", price: 1200, default: true, img: "1-liter.png" },
      { label: "03 Litre Packing", price: 3400, img: "3-liter.png" }
    ],
    size: "01 Liter Packing",
    origin: "Darkhshan Verified Quality Farm Batch",
    groveCoordinates: "Selected Canola Harvest",
    smokePoint: "460°F (238°C)",
    acidity: "< 0.09% (Chef Selection)",
    polyphenols: "Natural Plant Tocopherols",
    extraction: "Low-Heat Mechanical Expeller Press",
    harvestDate: "July 2026 Rate Release",
    rating: 4.9,
    reviewsCount: 98,
    badge: "CULINARY MASTER GRADE",
    description: "Optimized for home chefs and culinary kitchens requiring clean thermal performance without flavor masking or heavy lingering aftertaste.",
    culinaryUses: "Sautéed vegetables, pan-seared meats, delicate seafood, and fluffy baked goods.",
    images: ["1-liter.png", "3-liter.png"],
    image: "1-liter.png"
  },
  {
    id: "prod-cpa-lowchol",
    categoryId: "cold-pressed-a",
    category: "Cold Pressed 'A' Quality (Slightly Treated)",
    categoryBadge: "HEART CARE ACTIVE",
    name: "HEARTEN 'A' Quality Heart-Care Canola",
    subtitle: "Naturally Rich in Monounsaturated Fatty Acids",
    grade: "Cold Pressed A Quality (Slightly Treated)",
    price: 1200,
    sizes: [
      { label: "01 Liter Packing", price: 1200, default: true, img: "1-liter.png" },
      { label: "03 Litre Packing", price: 3400, img: "3-liter.png" }
    ],
    size: "01 Liter Packing",
    origin: "Low-Erucic Acid Seed Harvest",
    groveCoordinates: "Heart-Care Research Groves",
    smokePoint: "460°F (238°C)",
    acidity: "< 0.10% (Heart Care)",
    polyphenols: "Plant Sterols for Cholesterol Balance",
    extraction: "Gentle Cold Expeller Press",
    harvestDate: "July 2026 Rate Release",
    rating: 4.9,
    reviewsCount: 115,
    badge: "HEART CARE ACTIVE",
    description: "Formulated to maintain cardiovascular wellness. Extremely low in saturated fats and enriched with natural monounsaturated plant fats for daily vitality.",
    culinaryUses: "Diet-conscious cooking, heart-friendly dishes, steamed vegetables, and light pan cooking.",
    images: ["1-liter.png", "3-liter.png"],
    image: "1-liter.png"
  }
];

// Helper to resolve asset path in Shopify
function getAssetUrl(filename) {
  if (filename.startsWith('http') || filename.startsWith('/') || filename.startsWith('assets/')) {
    return filename;
  }
  return window.HEARTEN_ASSETS_DIR ? `${window.HEARTEN_ASSETS_DIR}/${filename}` : `assets/${filename}`;
}

// 2 Core Categories for Home Page
const categoriesDB = [
  {
    id: "extra-virgin",
    num: "1.",
    name: "Extra Virgin Cold Pressed",
    badge: "UNPROCESSED",
    badgeClass: "bg-gradient-to-r from-amber-500 to-amber-600 text-white",
    numBg: "bg-amber-500/15 text-amber-700",
    borderClass: "border-amber-400/60 hover:border-amber-500",
    headerBg: "bg-gradient-to-br from-amber-50/90 via-surface-container-lowest to-surface-container-low",
    accentColor: "#d97706",
    subtitle: "100% Pure & Unprocessed",
    desc: "100% pure first cold mechanical expeller press extracted below 22°C without chemicals, heat, or refining. Packed with bioactive Omega-3 lipids & natural polyphenols.",
    packing1L: "Rs. 1,600",
    packing3L: "Rs. 4,500",
    urduTitle: "ایکسٹرا ورجن کولڈ پریسڈ",
    urduDesc: "خالص، بغیر کسی کیمیکل یا حرارت کے تیار شدہ",
    totalProducts: 4
  },
  {
    id: "cold-pressed-a",
    num: "2.",
    name: "Cold Pressed A Quality",
    badge: "SLIGHTLY TREATED",
    badgeClass: "bg-gradient-to-r from-emerald-600 to-emerald-700 text-white",
    numBg: "bg-emerald-500/15 text-emerald-800",
    borderClass: "border-emerald-500/60 hover:border-emerald-600",
    headerBg: "bg-gradient-to-br from-emerald-50/90 via-surface-container-lowest to-surface-container-low",
    accentColor: "#059669",
    subtitle: "Premium Daily Grade",
    desc: "Mechanical expeller pressed followed by gentle natural micro-clarification for everyday crystal-clear frying and balanced cholesterol defense.",
    packing1L: "Rs. 1,200",
    packing3L: "Rs. 3,400",
    urduTitle: "کولڈ پریسڈ اے کوالٹی",
    urduDesc: "قدرتی فلٹر شدہ، روزمرہ بہترین کوکنگ کے لیے",
    totalProducts: 4
  }
];

// LocalStorage State Management
function getStoredWishlist() {
  try {
    const saved = localStorage.getItem('hearten_wishlist');
    if (!saved) return [];
    const parsed = JSON.parse(saved);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter(id => id && productsDB.some(p => p.id === id));
  } catch(e) {
    return [];
  }
}

function saveWishlistToStorage(data) {
  try {
    localStorage.setItem('hearten_wishlist', JSON.stringify(data));
  } catch(e) {}
}

function getStoredCart() {
  try {
    const saved = localStorage.getItem('hearten_cart');
    if (!saved) return [];
    const parsed = JSON.parse(saved);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter(item => item && item.id && productsDB.some(p => p.id === item.id));
  } catch(e) {
    return [];
  }
}

function saveCartToStorage(data) {
  try {
    localStorage.setItem('hearten_cart', JSON.stringify(data));
  } catch(e) {}
}

let wishlist = getStoredWishlist();
let cart = getStoredCart();

const HEARTEN_APP = {
  config: {
    whatsappNumber: window.HEARTEN_SETTINGS?.whatsappNumber || '923470717918',
    whatsappDisplay: window.HEARTEN_SETTINGS?.whatsappDisplay || '0347-0717-918',
    email: window.HEARTEN_SETTINGS?.contactEmail || 'darakhshan.ltd@gmail.com',
    freeShippingThreshold: window.HEARTEN_SETTINGS?.freeShippingThreshold || 10000,
    standardShippingFee: window.HEARTEN_SETTINGS?.standardShippingFee || 250
  },

  selectedSizes: {},

  init() {
    this.renderHomeCategories();
    updateWishlistUI();
    updateCartUI();
    this.bindGlobalEvents();
  },

  renderHomeCategories() {
    const container = document.getElementById('home-categories-container');
    if (!container) return;

    container.innerHTML = categoriesDB.map(cat => {
      const catProducts = productsDB.filter(p => p.categoryId === cat.id).slice(0, 4);

      const productsHtml = catProducts.map(prod => {
        const isFav = wishlist.includes(prod.id);
        const currentSizeIdx = this.selectedSizes[prod.id] || 0;
        const currentSize = prod.sizes[currentSizeIdx] || prod.sizes[0];
        const currentPrice = currentSize.price;
        const currentImg = getAssetUrl(currentSize.img || prod.image);

        return `
          <div class="bg-surface-container-lowest rounded-2xl border border-secondary/20 shadow-sm p-4 sm:p-5 flex flex-col justify-between hover:shadow-lg hover:border-primary/40 transition-all duration-300 relative group">
            
            <!-- Top Badge Row -->
            <div class="flex items-center justify-between gap-2 mb-3">
              <span class="font-label-sm text-[10px] font-bold uppercase tracking-wider px-2.5 py-0.5 rounded-full ${cat.badgeClass}">
                ${prod.badge}
              </span>
              <button 
                id="heart-btn-${prod.id}"
                onclick="toggleWishlist('${prod.id}')" 
                class="w-9 h-9 flex items-center justify-center rounded-full hover:bg-surface-container-high transition-colors cursor-pointer"
                title="Save to favorites"
              >
                <span class="material-symbols-outlined text-[20px] ${isFav ? 'text-error' : 'text-on-surface-variant'}" style="font-variation-settings: 'FILL' ${isFav ? 1 : 0};">
                  ${isFav ? 'favorite' : 'favorite_border'}
                </span>
              </button>
            </div>

            <!-- Product Image -->
            <div class="relative aspect-square rounded-xl bg-surface-container-low flex items-center justify-center p-3 mb-4 overflow-hidden">
              <a href="/collections/all" class="w-full h-full flex items-center justify-center">
                <img 
                  id="prod-img-${prod.id}"
                  src="${currentImg}" 
                  alt="${prod.name}" 
                  class="max-h-full w-auto object-contain group-hover:scale-105 transition-transform duration-500 drop-shadow-md"
                />
              </a>
            </div>

            <!-- Product Details -->
            <div class="flex-1 flex flex-col justify-between space-y-3">
              <div>
                <div class="flex items-center gap-1.5 text-xs text-on-surface-variant mb-1">
                  <span class="material-symbols-outlined text-[15px] text-primary">verified</span>
                  <span class="truncate">${prod.origin}</span>
                </div>
                <h3 class="font-headline-sm text-base sm:text-lg text-on-surface font-bold leading-snug">
                  <a href="/collections/all" class="hover:text-primary transition-colors">${prod.name}</a>
                </h3>
                <p class="font-body-sm text-xs text-on-surface-variant line-clamp-2 mt-1 leading-relaxed">${prod.description}</p>
              </div>

              <!-- Size Selection Buttons (1L / 3L) -->
              <div class="space-y-1.5 pt-2 border-t border-secondary/15">
                <span class="text-[10px] font-bold text-on-surface-variant uppercase tracking-wider block">Bottle Format:</span>
                <div class="grid grid-cols-2 gap-1.5">
                  ${prod.sizes.map((s, idx) => `
                    <button 
                      type="button" 
                      onclick="HEARTEN_APP.changeProductSize('${prod.id}', ${idx})" 
                      class="px-2 py-1.5 rounded-lg text-xs font-semibold border transition-all text-center cursor-pointer ${idx === currentSizeIdx ? 'border-primary bg-primary/10 text-primary font-bold ring-1 ring-primary/30' : 'border-secondary/25 bg-surface-container-low text-on-surface hover:border-primary/40'}"
                    >
                      ${s.label}
                    </button>
                  `).join('')}
                </div>
              </div>

              <!-- Price & Actions Row -->
              <div class="pt-2 border-t border-secondary/15 space-y-2.5">
                <div class="flex items-baseline justify-between">
                  <div>
                    <span class="text-[10px] text-on-surface-variant block">Price:</span>
                    <span id="prod-price-${prod.id}" class="font-headline-sm text-xl font-bold text-primary">
                      Rs. ${currentPrice.toLocaleString('en-PK')}
                    </span>
                  </div>
                  <span class="text-[11px] text-[#25D366] font-bold flex items-center gap-1">
                    <span class="w-1.5 h-1.5 rounded-full bg-[#25D366] animate-pulse"></span> In Stock
                  </span>
                </div>

                <div class="grid grid-cols-2 gap-2">
                  <button 
                    type="button" 
                    onclick="addToCart('${prod.id}')" 
                    class="w-full inline-flex items-center justify-center gap-1.5 bg-primary hover:bg-primary/90 text-white py-2.5 px-2 rounded-xl font-bold text-xs shadow-sm hover:shadow transition-all active:scale-95 cursor-pointer"
                  >
                    <span class="material-symbols-outlined text-[16px]">add_shopping_cart</span>
                    <span>Add to Cart</span>
                  </button>

                  <button 
                    type="button" 
                    onclick="buyProductDirectly('${prod.id}')" 
                    class="w-full inline-flex items-center justify-center gap-1.5 bg-[#25D366] hover:bg-[#20bd5a] text-white py-2.5 px-2 rounded-xl font-bold text-xs shadow-sm transition-all active:scale-95 cursor-pointer whitespace-nowrap"
                  >
                    <svg class="w-3.5 h-3.5 fill-current" viewBox="0 0 24 24"><path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z"/></svg>
                    <span>WhatsApp</span>
                  </button>
                </div>
              </div>
            </div>

          </div>
        `;
      }).join('');

      return `
        <div class="space-y-6">
          <!-- Category Header Box -->
          <div class="rounded-3xl p-6 sm:p-8 border ${cat.borderClass} ${cat.headerBg} shadow-sm">
            <div class="flex flex-col md:flex-row md:items-center justify-between gap-4">
              <div class="space-y-2 max-w-2xl">
                <div class="flex items-center gap-2.5">
                  <span class="w-8 h-8 rounded-full ${cat.numBg} font-bold text-sm flex items-center justify-center">${cat.num}</span>
                  <h2 class="font-headline-lg text-2xl sm:text-3xl font-bold text-on-surface">${cat.name}</h2>
                  <span class="font-label-sm text-xs font-bold px-3 py-1 rounded-full ${cat.badgeClass}">${cat.badge}</span>
                </div>
                <p class="font-body-sm text-xs sm:text-sm text-on-surface-variant leading-relaxed">${cat.desc}</p>
                <div class="text-xs font-semibold text-primary" dir="rtl">
                  <span>${cat.urduTitle} — ${cat.urduDesc}</span>
                </div>
              </div>

              <!-- Rates Pill -->
              <div class="flex flex-wrap sm:flex-nowrap items-center gap-3 bg-white/90 backdrop-blur-sm p-3.5 rounded-2xl border border-secondary/20 shadow-xs shrink-0">
                <div class="text-center px-3 border-r border-secondary/15">
                  <span class="text-[10px] text-on-surface-variant block uppercase font-bold">1L Packing</span>
                  <span class="font-headline-sm text-base sm:text-lg font-bold text-primary">${cat.packing1L}</span>
                </div>
                <div class="text-center px-3">
                  <span class="text-[10px] text-on-surface-variant block uppercase font-bold">3L Packing</span>
                  <span class="font-headline-sm text-base sm:text-lg font-bold text-primary">${cat.packing3L}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Category Products Grid -->
          <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
            ${productsHtml}
          </div>
        </div>
      `;
    }).join('');
  },

  changeProductSize(productId, sizeIdx) {
    this.selectedSizes[productId] = sizeIdx;
    const prod = productsDB.find(p => p.id === productId);
    if (!prod) return;

    const size = prod.sizes[sizeIdx] || prod.sizes[0];
    const priceEl = document.getElementById(`prod-price-${productId}`);
    const imgEl = document.getElementById(`prod-img-${productId}`);

    if (priceEl) priceEl.textContent = `Rs. ${size.price.toLocaleString('en-PK')}`;
    if (imgEl && size.img) imgEl.src = getAssetUrl(size.img);

    this.renderHomeCategories();
  },

  bindGlobalEvents() {
    // Escape key closes modals
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        closeCart();
        closeWishlist();
        closeCheckoutModal();
        closeSuccessModal();
        closeReportModal();
      }
    });
  }
};

// Wishlist Logic
function updateWishlistUI() {
  const badge = document.getElementById('wishlist-badge');
  const drawerCount = document.getElementById('wishlist-drawer-count');
  const container = document.getElementById('wishlist-items-container');
  const navIcon = document.getElementById('wishlist-icon-nav');

  wishlist = wishlist.filter(id => id && productsDB.some(p => p.id === id));

  if (badge) {
    badge.textContent = wishlist.length;
    if (wishlist.length > 0) {
      badge.classList.remove('hidden');
      badge.style.display = 'flex';
    } else {
      badge.classList.add('hidden');
      badge.style.display = 'none';
    }
  }

  if (navIcon) {
    if (wishlist.length > 0) {
      navIcon.textContent = 'favorite';
      navIcon.classList.add('text-error');
      navIcon.style.fontVariationSettings = "'FILL' 1";
    } else {
      navIcon.textContent = 'favorite_border';
      navIcon.classList.remove('text-error');
      navIcon.style.fontVariationSettings = "'FILL' 0";
    }
  }

  if (drawerCount) {
    drawerCount.textContent = `${wishlist.length} item${wishlist.length !== 1 ? 's' : ''}`;
  }

  productsDB.forEach(prod => {
    const btn = document.getElementById(`heart-btn-${prod.id}`);
    if (btn) {
      const isFav = wishlist.includes(prod.id);
      btn.innerHTML = `<span class="material-symbols-outlined text-[20px] ${isFav ? 'text-error' : 'text-on-surface-variant'}" style="font-variation-settings: 'FILL' ${isFav ? 1 : 0};">${isFav ? 'favorite' : 'favorite_border'}</span>`;
    }
  });

  if (container) {
    if (wishlist.length === 0) {
      container.innerHTML = `
        <div class="text-center py-12 flex flex-col items-center justify-center">
          <span class="material-symbols-outlined text-outline text-[54px] mb-3">favorite_border</span>
          <p class="font-headline-sm text-lg text-on-surface font-semibold mb-1">Your Wishlist is Empty</p>
          <p class="font-body-sm text-sm text-on-surface-variant max-w-xs mb-6">Explore our pure canola and vegetable cooking oils and click the heart icon on any bottle to save it here.</p>
          <a href="/collections/all" class="px-6 py-2.5 rounded-full bg-primary-container text-on-primary font-label-md text-sm">Explore Products</a>
        </div>
      `;
    } else {
      container.innerHTML = wishlist.map(id => {
        const item = productsDB.find(p => p.id === id);
        if (!item) return '';
        return `
          <div class="flex items-center gap-4 p-3 bg-surface-container-low rounded-xl border border-secondary/15 hover:border-secondary/30 transition-all">
            <a href="/collections/all" class="shrink-0">
              <img src="${getAssetUrl(item.image)}" alt="${item.name}" class="w-16 h-16 object-contain rounded-lg bg-surface-container-lowest p-1 hover:scale-105 transition-transform" />
            </a>
            <div class="flex-1 min-w-0">
              <h4 class="font-headline-sm text-sm text-on-surface font-semibold truncate">
                <a href="/collections/all" class="hover:text-primary hover:underline">${item.name}</a>
              </h4>
              <p class="font-body-sm text-xs text-on-surface-variant">${item.size} · Rs. ${item.price.toLocaleString('en-PK')}</p>
              <div class="flex items-center gap-2 mt-2">
                <button onclick="addToCart('${item.id}'); toggleWishlist('${item.id}');" class="text-xs text-primary font-semibold hover:underline flex items-center gap-1 cursor-pointer">
                  <span class="material-symbols-outlined text-[14px]">shopping_bag</span> Move to Cart
                </button>
                <a href="/collections/all" class="text-xs text-secondary font-semibold hover:underline flex items-center gap-1 ml-2">
                  <span class="material-symbols-outlined text-[14px]">visibility</span> View Details
                </a>
              </div>
            </div>
            <button onclick="toggleWishlist('${item.id}')" class="p-1.5 text-on-surface-variant/70 hover:text-error rounded-full hover:bg-surface-container cursor-pointer" title="Remove from favorites">
              <span class="material-symbols-outlined text-[18px]">close</span>
            </button>
          </div>
        `;
      }).join('');
    }
  }
}

function toggleWishlist(productId) {
  const item = productsDB.find(p => p.id === productId);
  if (!item) return;
  
  const index = wishlist.indexOf(productId);
  if (index > -1) {
    wishlist.splice(index, 1);
    showToast(`Removed ${item.name} from Wishlist`, 'favorite_border');
  } else {
    wishlist.push(productId);
    showToast(`Saved ${item.name} to Wishlist!`, 'favorite');
  }
  saveWishlistToStorage(wishlist);
  updateWishlistUI();
}

// Cart Logic
function updateCartUI() {
  const badge = document.getElementById('cart-badge');
  const drawerCount = document.getElementById('cart-drawer-count');
  const container = document.getElementById('cart-items-container');
  const subtotalEl = document.getElementById('cart-subtotal-price');
  const progressBar = document.getElementById('shipping-progress-bar');
  const progressText = document.getElementById('shipping-progress-text');

  cart = cart.filter(item => item && item.id && productsDB.some(p => p.id === item.id));

  const totalQty = cart.reduce((sum, item) => sum + (item.qty || 1), 0);
  if (badge) {
    badge.textContent = totalQty;
    if (totalQty > 0) {
      badge.classList.remove('hidden');
      badge.style.display = 'flex';
    } else {
      badge.classList.add('hidden');
      badge.style.display = 'none';
    }
  }

  if (drawerCount) {
    drawerCount.textContent = `${totalQty} item${totalQty !== 1 ? 's' : ''}`;
  }

  let subtotal = 0;
  cart.forEach(c => {
    const prod = productsDB.find(p => p.id === c.id);
    if (prod) {
      const itemPrice = c.price || prod.price;
      subtotal += itemPrice * (c.qty || 1);
    }
  });

  if (subtotalEl) {
    subtotalEl.textContent = `Rs. ${subtotal.toLocaleString('en-PK')}`;
  }

  const freeShippingGoal = 10000;
  if (progressBar && progressText) {
    if (subtotal >= freeShippingGoal) {
      progressBar.style.width = '100%';
      progressText.textContent = 'Unlocked Free Shipping!';
      progressText.classList.add('text-primary');
    } else {
      const remaining = freeShippingGoal - subtotal;
      const pct = Math.min(100, Math.round((subtotal / freeShippingGoal) * 100));
      progressBar.style.width = `${pct}%`;
      progressText.textContent = `Rs. ${remaining.toLocaleString('en-PK')} away`;
      progressText.classList.remove('text-primary');
    }
  }

  if (container) {
    if (cart.length === 0) {
      container.innerHTML = `
        <div class="text-center py-12 flex flex-col items-center justify-center">
          <span class="material-symbols-outlined text-outline text-[54px] mb-3">shopping_bag</span>
          <p class="font-headline-sm text-lg text-on-surface font-semibold mb-1">Your Cart is Empty</p>
          <p class="font-body-sm text-sm text-on-surface-variant max-w-xs mb-6">Discover canola & vegetable cooking oils mechanical stone-pressed with zero heat or solvents.</p>
          <a href="/collections/all" class="px-6 py-2.5 rounded-full bg-primary-container text-on-primary font-label-md text-sm">Explore Catalog</a>
        </div>
      `;
    } else {
      container.innerHTML = cart.map(item => {
        const prod = productsDB.find(p => p.id === item.id);
        if (!prod) return '';
        const itemSize = item.size || prod.size;
        const itemPrice = item.price || prod.price;
        return `
          <div class="flex items-center gap-4 p-3.5 bg-surface-container-low rounded-xl border border-secondary/15">
            <a href="/collections/all" class="shrink-0">
              <img src="${getAssetUrl(item.img || prod.image)}" alt="${prod.name}" class="w-16 h-16 object-contain rounded-lg bg-surface-container-lowest p-1 hover:scale-105 transition-transform" />
            </a>
            <div class="flex-1 min-w-0">
              <h4 class="font-headline-sm text-sm text-on-surface font-semibold truncate">
                <a href="/collections/all" class="hover:text-primary hover:underline">${prod.name}</a>
              </h4>
              <p class="font-body-sm text-xs text-on-surface-variant">${itemSize} · Rs. ${itemPrice.toLocaleString('en-PK')}</p>
              <div class="flex items-center gap-3 mt-2">
                <div class="flex items-center border border-secondary/30 rounded-full bg-surface-container-lowest px-2 py-0.5">
                  <button type="button" onclick="updateCartQty('${prod.id}', -1)" class="text-on-surface-variant hover:text-primary px-1 text-sm font-bold cursor-pointer">-</button>
                  <span class="px-2 text-xs font-bold text-on-surface">${item.qty}</span>
                  <button type="button" onclick="updateCartQty('${prod.id}', 1)" class="text-on-surface-variant hover:text-primary px-1 text-sm font-bold cursor-pointer">+</button>
                </div>
                <span class="font-label-md text-xs text-primary font-bold">Rs. ${(itemPrice * item.qty).toLocaleString('en-PK')}</span>
              </div>
            </div>
            <button type="button" onclick="removeFromCart('${prod.id}')" class="p-1.5 text-on-surface-variant/70 hover:text-error rounded-full hover:bg-surface-container cursor-pointer" title="Remove item">
              <span class="material-symbols-outlined text-[18px]">delete</span>
            </button>
          </div>
        `;
      }).join('');
    }
  }
}

function addToCart(productId) {
  const prod = productsDB.find(p => p.id === productId);
  if (!prod) return;
  
  const sizeIdx = HEARTEN_APP.selectedSizes[productId] || 0;
  const sizeObj = prod.sizes[sizeIdx] || prod.sizes[0];

  const existing = cart.find(c => c.id === productId && c.size === sizeObj.label);
  if (existing) {
    existing.qty += 1;
  } else {
    cart.push({ id: productId, qty: 1, size: sizeObj.label, price: sizeObj.price, img: sizeObj.img || prod.image });
  }
  saveCartToStorage(cart);
  updateCartUI();
  showToast(`Added ${prod.name} (${sizeObj.label}) to cart!`, 'add_shopping_cart');
}

function updateCartQty(productId, change) {
  const item = cart.find(c => c.id === productId);
  if (!item) return;
  
  item.qty += change;
  if (item.qty <= 0) {
    cart = cart.filter(c => c !== item);
  }
  saveCartToStorage(cart);
  updateCartUI();
}

function removeFromCart(productId) {
  const prod = productsDB.find(p => p.id === productId);
  cart = cart.filter(c => c.id !== productId);
  saveCartToStorage(cart);
  updateCartUI();
  if (prod) showToast(`Removed ${prod.name} from cart`, 'remove_shopping_cart');
}

function buyProductDirectly(productId) {
  const prod = productsDB.find(p => p.id === productId);
  if (!prod) return;

  const sizeIdx = HEARTEN_APP.selectedSizes[productId] || 0;
  const sizeObj = prod.sizes[sizeIdx] || prod.sizes[0];

  const total = sizeObj.price;
  const msg = `Hello HEARTEN! 🌿 I would like to buy:
1. *${prod.name}* (${sizeObj.label}) — Rs. ${total.toLocaleString('en-PK')}

📍 *Contact Helpline:* ${HEARTEN_APP.config.whatsappDisplay}
Please confirm availability and share payment/delivery confirmation.`;

  const url = `https://wa.me/${HEARTEN_APP.config.whatsappNumber}?text=${encodeURIComponent(msg)}`;
  window.open(url, '_blank');
}

function checkoutViaWhatsApp() {
  const cartItems = getStoredCart();
  if (!cartItems || cartItems.length === 0) {
    showToast('Your cart is empty! Add cooking oils to cart first.', 'shopping_bag');
    return;
  }
  let subtotal = 0;
  let itemsText = [];
  cartItems.forEach((item, i) => {
    const prod = productsDB.find(p => p.id === item.id);
    const name = prod ? prod.name : 'HEARTEN Pure Cooking Oil';
    const size = item.size || (prod ? prod.size : '1 Liter');
    const price = item.price || (prod ? prod.price : 0);
    const itemTotal = price * (item.qty || 1);
    subtotal += itemTotal;
    itemsText.push(`${i + 1}. *${name}* (${size}) — Qty: ${item.qty} — Rs. ${itemTotal.toLocaleString('en-PK')}`);
  });

  const isFree = subtotal >= HEARTEN_APP.config.freeShippingThreshold;
  const shipping = isFree ? 0 : HEARTEN_APP.config.standardShippingFee;
  const grandTotal = subtotal + shipping;

  const msg = `📢 *NEW ORDER CONFIRMED (WHATSAPP CART)* 🌿
*Is Client Ne Order Confirm Kiya Hai:*

${itemsText.join('\n')}

💵 *Subtotal:* Rs. ${subtotal.toLocaleString('en-PK')}
🚚 *Delivery Fee:* ${isFree ? 'FREE' : 'Rs. ' + shipping}
💰 *Total Payable:* Rs. ${grandTotal.toLocaleString('en-PK')}

✅ *Status:* Is client ne website cart se direct WhatsApp order confirm kiya hai. Kindly process and dispatch.`;

  const whatsappUrl = `https://wa.me/${HEARTEN_APP.config.whatsappNumber}?text=${encodeURIComponent(msg)}`;
  window.open(whatsappUrl, '_blank');
}

// Drawer Toggles
function openWishlist() {
  const wishlistBackdrop = document.getElementById('wishlist-backdrop');
  const wishlistDrawer = document.getElementById('wishlist-drawer');
  if (wishlistBackdrop && wishlistDrawer) {
    wishlistBackdrop.classList.remove('opacity-0', 'pointer-events-none');
    wishlistBackdrop.classList.add('opacity-100');
    wishlistDrawer.classList.remove('translate-x-full');
  }
}
function closeWishlist() {
  const wishlistBackdrop = document.getElementById('wishlist-backdrop');
  const wishlistDrawer = document.getElementById('wishlist-drawer');
  if (wishlistBackdrop && wishlistDrawer) {
    wishlistBackdrop.classList.remove('opacity-100');
    wishlistBackdrop.classList.add('opacity-0', 'pointer-events-none');
    wishlistDrawer.classList.add('translate-x-full');
  }
}

function openCart() {
  const cartBackdrop = document.getElementById('cart-backdrop');
  const cartDrawer = document.getElementById('cart-drawer');
  if (cartBackdrop && cartDrawer) {
    cartBackdrop.classList.remove('opacity-0', 'pointer-events-none');
    cartBackdrop.classList.add('opacity-100');
    cartDrawer.classList.remove('translate-x-full');
  }
}
function closeCart() {
  const cartBackdrop = document.getElementById('cart-backdrop');
  const cartDrawer = document.getElementById('cart-drawer');
  if (cartBackdrop && cartDrawer) {
    cartBackdrop.classList.remove('opacity-100');
    cartBackdrop.classList.add('opacity-0', 'pointer-events-none');
    cartDrawer.classList.add('translate-x-full');
  }
}

function openMobileNav() {
  const mobileNavBackdrop = document.getElementById('mobile-nav-backdrop');
  const mobileNavDrawer = document.getElementById('mobile-nav-drawer');
  if (mobileNavBackdrop && mobileNavDrawer) {
    mobileNavBackdrop.classList.remove('opacity-0', 'pointer-events-none');
    mobileNavBackdrop.classList.add('opacity-100');
    mobileNavDrawer.classList.remove('translate-x-full');
  }
}
function closeMobileNavMenu() {
  const mobileNavBackdrop = document.getElementById('mobile-nav-backdrop');
  const mobileNavDrawer = document.getElementById('mobile-nav-drawer');
  if (mobileNavBackdrop && mobileNavDrawer) {
    mobileNavBackdrop.classList.remove('opacity-100');
    mobileNavBackdrop.classList.add('opacity-0', 'pointer-events-none');
    mobileNavDrawer.classList.add('translate-x-full');
  }
}

// Search Implementation
function renderSearchResults(query) {
  const searchDropdown = document.getElementById('search-results-dropdown');
  const clearSearchBtn = document.getElementById('clear-search-btn');
  const searchResultsList = document.getElementById('search-results-list');
  const searchCount = document.getElementById('search-count');

  if (!query || query.trim() === '') {
    if (searchDropdown) searchDropdown.classList.add('hidden');
    if (clearSearchBtn) clearSearchBtn.classList.add('hidden');
    return;
  }

  if (clearSearchBtn) clearSearchBtn.classList.remove('hidden');
  const q = query.toLowerCase().trim();
  const matches = productsDB.filter(p => 
    p.name.toLowerCase().includes(q) ||
    p.category.toLowerCase().includes(q) ||
    p.origin.toLowerCase().includes(q) ||
    p.smokePoint.toLowerCase().includes(q)
  );

  if (searchCount) searchCount.textContent = `${matches.length} result${matches.length !== 1 ? 's' : ''}`;
  if (searchDropdown) searchDropdown.classList.remove('hidden');

  if (!searchResultsList) return;

  if (matches.length === 0) {
    searchResultsList.innerHTML = `
      <div class="p-6 text-center text-on-surface-variant">
        <span class="material-symbols-outlined text-[32px] text-outline mb-1">sentiment_dissatisfied</span>
        <p class="font-body-md text-sm font-medium">No canola and vegetable cooking oils match "${query}"</p>
        <p class="font-body-sm text-xs mt-1">Try searching for "Canola", "Vegetable", "Frying", or "Seed".</p>
      </div>
    `;
  } else {
    searchResultsList.innerHTML = matches.map(prod => `
      <div class="flex items-center gap-3 p-3 hover:bg-surface-container-low transition-colors group">
        <a href="/collections/all" class="shrink-0">
          <img src="${getAssetUrl(prod.image)}" alt="${prod.name}" class="w-12 h-12 object-contain bg-surface-container-lowest rounded-lg p-1 border border-secondary/15 hover:scale-105 transition-transform" />
        </a>
        <div class="flex-1 min-w-0">
          <a href="/collections/all" class="font-headline-sm text-sm text-on-surface font-semibold group-hover:text-primary truncate block hover:underline">${prod.name}</a>
          <div class="flex items-center gap-2 text-xs text-on-surface-variant">
            <span>${prod.size}</span>
            <span>·</span>
            <span class="font-bold text-primary">Rs. ${prod.price.toLocaleString('en-PK')}</span>
            <span>·</span>
            <span class="truncate">${prod.origin}</span>
          </div>
        </div>
        <div class="flex items-center gap-1.5">
          <button onclick="toggleWishlist('${prod.id}')" class="p-1.5 text-on-surface-variant hover:text-error rounded-full cursor-pointer" title="Wishlist">
            <span class="material-symbols-outlined text-[18px]">favorite_border</span>
          </button>
          <button onclick="addToCart('${prod.id}')" class="p-1.5 bg-primary-container hover:bg-primary text-on-primary rounded-full shadow-sm cursor-pointer" title="Add to Cart">
            <span class="material-symbols-outlined text-[18px]">add_shopping_cart</span>
          </button>
        </div>
      </div>
    `).join('');
  }
}

// Full Screen Checkout Modal Logic
function openCheckoutModal() {
  closeCart();
  const modal = document.getElementById('checkout-modal');
  if (modal) {
    modal.classList.remove('hidden');
    modal.classList.add('flex');
    document.body.style.overflow = 'hidden';
    renderCheckoutMiniSummary();
  }
}

function closeCheckoutModal() {
  const modal = document.getElementById('checkout-modal');
  if (modal) {
    modal.classList.add('hidden');
    modal.classList.remove('flex');
    document.body.style.overflow = '';
  }
}

function closeSuccessModal() {
  const modal = document.getElementById('order-success-modal');
  if (modal) {
    modal.classList.add('hidden');
    document.body.style.overflow = '';
  }
}

function openReportModal() {
  const modal = document.getElementById('reportModal');
  if (modal) {
    modal.classList.remove('hidden');
    modal.classList.add('flex');
    document.body.style.overflow = 'hidden';
  }
}

function closeReportModal() {
  const modal = document.getElementById('reportModal');
  if (modal) {
    modal.classList.add('hidden');
    modal.classList.remove('flex');
    document.body.style.overflow = '';
  }
}

function renderCheckoutMiniSummary() {
  const listEl = document.getElementById('checkout-items-mini-list');
  const countBadge = document.getElementById('checkout-items-count-badge');
  const subtotalEl = document.getElementById('checkout-subtotal-val');
  const shippingEl = document.getElementById('checkout-shipping-val');
  const totalEl = document.getElementById('checkout-total-val');

  if (!listEl) return;

  const cartItems = getStoredCart();
  const totalQty = cartItems.reduce((sum, item) => sum + (item.qty || 1), 0);
  if (countBadge) countBadge.textContent = `${totalQty} item${totalQty !== 1 ? 's' : ''}`;

  let subtotal = 0;
  if (cartItems.length === 0) {
    listEl.innerHTML = `<p class="text-xs text-on-surface-variant py-4 text-center">Your cart is empty.</p>`;
  } else {
    listEl.innerHTML = cartItems.map(item => {
      const prod = productsDB.find(p => p.id === item.id);
      const name = prod ? prod.name : 'HEARTEN Pure Oil';
      const size = item.size || (prod ? prod.size : '1 Liter');
      const price = item.price || (prod ? prod.price : 0);
      const lineTotal = price * (item.qty || 1);
      subtotal += lineTotal;

      return `
        <div class="flex items-center justify-between py-2 text-xs">
          <div class="flex items-center gap-2.5 min-w-0 pr-2">
            <img src="${getAssetUrl(item.img || prod?.image || '1-liter.png')}" alt="${name}" class="w-10 h-10 object-contain rounded-lg bg-surface-container-low p-1 border border-secondary/15 shrink-0" />
            <div class="truncate">
              <span class="font-bold text-on-surface block truncate">${name}</span>
              <span class="text-on-surface-variant">${size} x ${item.qty}</span>
            </div>
          </div>
          <span class="font-bold text-on-surface shrink-0">Rs. ${lineTotal.toLocaleString('en-PK')}</span>
        </div>
      `;
    }).join('');
  }

  const isFree = subtotal >= HEARTEN_APP.config.freeShippingThreshold;
  const shippingFee = isFree || subtotal === 0 ? 0 : HEARTEN_APP.config.standardShippingFee;
  const grandTotal = subtotal + shippingFee;

  if (subtotalEl) subtotalEl.textContent = `Rs. ${subtotal.toLocaleString('en-PK')}`;
  if (shippingEl) shippingEl.textContent = isFree ? 'FREE' : `Rs. ${shippingFee}`;
  if (totalEl) totalEl.textContent = `Rs. ${grandTotal.toLocaleString('en-PK')}`;
}

// Order Handling
function handlePlaceOrder(e) {
  if (e) e.preventDefault();

  const cartItems = getStoredCart();
  if (!cartItems || cartItems.length === 0) {
    showToast('Your cart is empty!', 'shopping_bag');
    return;
  }

  const name = document.getElementById('checkout-name')?.value.trim();
  const phone = document.getElementById('checkout-phone')?.value.trim();
  const email = document.getElementById('checkout-email')?.value.trim() || 'N/A';
  const address = document.getElementById('checkout-address')?.value.trim();
  const city = document.getElementById('checkout-city')?.value || 'Karachi';
  const notes = document.getElementById('checkout-notes')?.value.trim() || '';
  const paymentMethod = document.querySelector('input[name="payment_method"]:checked')?.value || 'Cash on Delivery (COD)';

  if (!name || !phone || !address) {
    showToast('Please enter your full name, phone number, and street address.', 'error');
    return;
  }

  const placeBtn = document.getElementById('place-order-btn');
  if (placeBtn) {
    placeBtn.disabled = true;
    placeBtn.innerHTML = `<span class="material-symbols-outlined animate-spin text-[18px]">progress_activity</span> <span>Processing Order...</span>`;
  }

  const orderId = 'HTN-' + Math.floor(10000 + Math.random() * 90000);
  let subtotal = 0;
  const itemsSummary = cartItems.map((item, i) => {
    const prod = productsDB.find(p => p.id === item.id);
    const prodName = prod ? prod.name : 'HEARTEN Cooking Oil';
    const prodSize = item.size || '1L';
    const price = item.price || (prod ? prod.price : 0);
    const lineTotal = price * (item.qty || 1);
    subtotal += lineTotal;
    return `${i + 1}. *${prodName}* (${prodSize}) x ${item.qty} — Rs. ${lineTotal.toLocaleString('en-PK')}`;
  });

  const isFree = subtotal >= HEARTEN_APP.config.freeShippingThreshold;
  const shipping = isFree ? 0 : HEARTEN_APP.config.standardShippingFee;
  const grandTotal = subtotal + shipping;

  setTimeout(() => {
    if (placeBtn) {
      placeBtn.disabled = false;
      placeBtn.innerHTML = `<span class="material-symbols-outlined text-[20px]">verified</span><span>Place Order Now</span>`;
    }

    closeCheckoutModal();

    // Formulate the EXACT required WhatsApp Message
    const whatsappMsg = `📢 *NEW ORDER CONFIRMED!* 🌿\n*Is Client Ne Order Confirm Kiya Hai:*\n\n🛒 *Order ID:* #${orderId}\n👤 *Client Name:* ${name}\n📱 *Client Phone:* ${phone}\n📧 *Email:* ${email}\n📍 *Delivery Address:* ${address}, ${city}\n💳 *Payment Method:* ${paymentMethod}\n${notes ? `📝 *Special Notes:* ${notes}\n` : ''}\n📦 *Ordered Items:*\n${itemsSummary.join('\n')}\n\n💵 *Subtotal:* Rs. ${subtotal.toLocaleString('en-PK')}\n🚚 *Delivery Fee:* ${isFree ? 'FREE' : 'Rs. ' + shipping}\n💰 *Total Payable:* Rs. ${grandTotal.toLocaleString('en-PK')}\n\n✅ *Status:* Is client ne website se order confirm kar diya hai. Kindly process and dispatch.`;

    const whatsappUrl = `https://wa.me/${HEARTEN_APP.config.whatsappNumber}?text=${encodeURIComponent(whatsappMsg)}`;

    // Show Success Modal
    const successModal = document.getElementById('order-success-modal');
    const successOrderId = document.getElementById('success-order-id');
    const successDetails = document.getElementById('success-order-details');
    const successWhatsAppBtn = document.getElementById('success-whatsapp-btn');

    if (successOrderId) successOrderId.textContent = `#${orderId}`;
    if (successDetails) {
      successDetails.innerHTML = `
        <div class="flex justify-between border-b border-secondary/15 pb-1.5">
          <span class="text-on-surface-variant">Customer:</span>
          <span class="font-bold text-on-surface">${name} (${phone})</span>
        </div>
        <div class="flex justify-between border-b border-secondary/15 pb-1.5">
          <span class="text-on-surface-variant">Delivery To:</span>
          <span class="font-medium text-on-surface text-right max-w-[200px] truncate">${address}, ${city}</span>
        </div>
        <div class="flex justify-between border-b border-secondary/15 pb-1.5">
          <span class="text-on-surface-variant">Payment Method:</span>
          <span class="font-bold text-primary">${paymentMethod}</span>
        </div>
        <div class="flex justify-between pt-1 text-sm font-bold text-on-surface">
          <span>Total Payable:</span>
          <span class="text-primary">Rs. ${grandTotal.toLocaleString('en-PK')}</span>
        </div>
      `;
    }

    if (successWhatsAppBtn) {
      successWhatsAppBtn.href = whatsappUrl;
    }

    if (successModal) {
      successModal.classList.remove('hidden');
      successModal.classList.add('flex');
      document.body.style.overflow = 'hidden';
    }

    // Automatically open WhatsApp in new window
    try {
      window.open(whatsappUrl, '_blank');
    } catch(err) {}

    // Clear Cart
    cart = [];
    saveCartToStorage(cart);
    updateCartUI();

    showToast(`Order #${orderId} placed successfully!`, 'check_circle');
  }, 800);
}

function sendCheckoutViaWhatsApp() {
  const cartItems = getStoredCart();
  if (!cartItems || cartItems.length === 0) {
    showToast('Your cart is empty!', 'shopping_bag');
    return;
  }

  const name = document.getElementById('checkout-name')?.value.trim() || 'Customer';
  const phone = document.getElementById('checkout-phone')?.value.trim() || '0347-XXXXXXX';
  const address = document.getElementById('checkout-address')?.value.trim() || 'Address not specified';
  const city = document.getElementById('checkout-city')?.value || 'Karachi';
  const notes = document.getElementById('checkout-notes')?.value.trim() || '';
  const paymentMethod = document.querySelector('input[name="payment_method"]:checked')?.value || 'Cash on Delivery (COD)';

  const orderId = 'HTN-' + Math.floor(10000 + Math.random() * 90000);
  let subtotal = 0;
  const itemsText = cartItems.map((item, i) => {
    const prod = productsDB.find(p => p.id === item.id);
    const prodName = prod ? prod.name : 'HEARTEN Cooking Oil';
    const prodSize = item.size || '1L';
    const price = item.price || (prod ? prod.price : 0);
    const lineTotal = price * (item.qty || 1);
    subtotal += lineTotal;
    return `${i + 1}. *${prodName}* (${prodSize}) x ${item.qty} — Rs. ${lineTotal.toLocaleString('en-PK')}`;
  });

  const isFree = subtotal >= HEARTEN_APP.config.freeShippingThreshold;
  const shipping = isFree ? 0 : HEARTEN_APP.config.standardShippingFee;
  const grandTotal = subtotal + shipping;

  const msg = `📢 *NEW ORDER CONFIRMED (DIRECT WHATSAPP)* 🌿\n*Is Client Ne Order Confirm Kiya Hai:*\n\n🛒 *Order Reference:* #${orderId}\n👤 *Client Name:* ${name}\n📱 *Client Phone:* ${phone}\n📍 *Delivery Address:* ${address}, ${city}\n💳 *Payment Method:* ${paymentMethod}\n${notes ? `📝 *Special Notes:* ${notes}\n` : ''}\n📦 *Ordered Items:*\n${itemsText.join('\n')}\n\n💵 *Subtotal:* Rs. ${subtotal.toLocaleString('en-PK')}\n🚚 *Delivery Fee:* ${isFree ? 'FREE' : 'Rs. ' + shipping}\n💰 *Total Payable:* Rs. ${grandTotal.toLocaleString('en-PK')}\n\n✅ *Status:* Is client ne WhatsApp ke zariye order confirm kiya hai. Kindly process and dispatch.`;

  const url = `https://wa.me/${HEARTEN_APP.config.whatsappNumber}?text=${encodeURIComponent(msg)}`;
  window.open(url, '_blank');
}

// Toast Function
function showToast(message, icon = 'info') {
  const toast = document.getElementById('toast-notification');
  const toastMsg = document.getElementById('toast-message');
  const toastIcon = document.getElementById('toast-icon');

  if (!toast || !toastMsg) return;

  toastMsg.textContent = message;
  if (toastIcon) toastIcon.textContent = icon;

  toast.classList.remove('translate-y-20', 'opacity-0', 'pointer-events-none');
  toast.classList.add('translate-y-0', 'opacity-100');

  if (window.toastTimeout) clearTimeout(window.toastTimeout);
  window.toastTimeout = setTimeout(() => {
    toast.classList.remove('translate-y-0', 'opacity-100');
    toast.classList.add('translate-y-20', 'opacity-0', 'pointer-events-none');
  }, 3500);
}

// Newsletter
function handleSubscribe(e, form) {
  if (e) e.preventDefault();
  const input = form.querySelector('input[type="email"]');
  if (input && input.value.trim()) {
    showToast('Thank you for subscribing! Seasonal dispatches on the way.', 'mark_email_read');
    input.value = '';
  }
}

// Initialize on DOM Ready
document.addEventListener('DOMContentLoaded', () => {
  // Ensure browser tab title always displays HEARTEN cleanly and removes any 'My Store'
  function sanitizePageTitle() {
    if (document.title.includes('My Store')) {
      document.title = document.title.replace(/My Store/gi, 'HEARTEN');
    } else if (!document.title.includes('HEARTEN')) {
      document.title = document.title ? `${document.title} – HEARTEN` : 'HEARTEN | Nature\'s Purest Canola & Vegetable Cooking Oils';
    }
  }
  sanitizePageTitle();

  HEARTEN_APP.init();

  // Search input listeners
  const searchInput = document.getElementById('global-search-input');
  const clearSearchBtn = document.getElementById('clear-search-btn');
  if (searchInput) {
    searchInput.addEventListener('input', (e) => renderSearchResults(e.target.value));
    searchInput.addEventListener('focus', (e) => {
      if (e.target.value.trim() !== '') {
        document.getElementById('search-results-dropdown')?.classList.remove('hidden');
      }
    });
  }
  if (clearSearchBtn) {
    clearSearchBtn.addEventListener('click', () => {
      if (searchInput) searchInput.value = '';
      document.getElementById('search-results-dropdown')?.classList.add('hidden');
      clearSearchBtn.classList.add('hidden');
    });
  }

  const mobileSearchInput = document.getElementById('mobile-search-input');
  if (mobileSearchInput) {
    mobileSearchInput.addEventListener('input', (e) => {
      if (searchInput) searchInput.value = e.target.value;
      renderSearchResults(e.target.value);
    });
  }

  // Wishlist & Cart click events
  const wishlistBtn = document.getElementById('wishlist-btn');
  const closeWishlistBtn = document.getElementById('close-wishlist-btn');
  const wishlistBackdrop = document.getElementById('wishlist-backdrop');
  const clearWishlistBtn = document.getElementById('clear-wishlist-btn');

  if (wishlistBtn) wishlistBtn.addEventListener('click', openWishlist);
  if (closeWishlistBtn) closeWishlistBtn.addEventListener('click', closeWishlist);
  if (wishlistBackdrop) wishlistBackdrop.addEventListener('click', closeWishlist);
  if (clearWishlistBtn) {
    clearWishlistBtn.addEventListener('click', () => {
      wishlist = [];
      saveWishlistToStorage(wishlist);
      updateWishlistUI();
      showToast('Wishlist cleared', 'delete');
    });
  }

  const cartBtn = document.getElementById('cart-btn');
  const closeCartBtn = document.getElementById('close-cart-btn');
  const cartBackdrop = document.getElementById('cart-backdrop');

  if (cartBtn) cartBtn.addEventListener('click', openCart);
  if (closeCartBtn) closeCartBtn.addEventListener('click', closeCart);
  if (cartBackdrop) cartBackdrop.addEventListener('click', closeCart);

  const mobileMenuBtn = document.getElementById('mobile-menu-btn');
  const closeMobileNav = document.getElementById('close-mobile-nav');
  const mobileNavBackdrop = document.getElementById('mobile-nav-backdrop');

  if (mobileMenuBtn) mobileMenuBtn.addEventListener('click', openMobileNav);
  if (closeMobileNav) closeMobileNav.addEventListener('click', closeMobileNavMenu);
  if (mobileNavBackdrop) mobileNavBackdrop.addEventListener('click', closeMobileNavMenu);

  const mobileSearchToggle = document.getElementById('mobile-search-toggle');
  const mobileSearchBar = document.getElementById('mobile-search-bar');
  if (mobileSearchToggle && mobileSearchBar) {
    mobileSearchToggle.addEventListener('click', () => {
      mobileSearchBar.classList.toggle('hidden');
      if (!mobileSearchBar.classList.contains('hidden')) {
        document.getElementById('mobile-search-input')?.focus();
      }
    });
  }

  // Close dropdown on outside click
  document.addEventListener('click', (e) => {
    if (!e.target.closest('#global-search-input') && !e.target.closest('#search-results-dropdown')) {
      document.getElementById('search-results-dropdown')?.classList.add('hidden');
    }
  });
});
